module.exports = __webpack_public_path__ + "img/xinwen1.61934e6a.jpg";